import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useActiveWeb3React } from '../../hooks'
import { useFetchListCallback, useFetchPairListCallback } from '../../hooks/useFetchListCallback'
import useInterval from '../../hooks/useInterval'
import useIsWindowVisible from '../../hooks/useIsWindowVisible'
import { AppDispatch, AppState } from '../index'
import { DEFAULT_PAIR_LIST_URL } from '../../constants/lists'

export default function Updater(): null {
  const { library } = useActiveWeb3React()
  const dispatch = useDispatch<AppDispatch>()
  const lists = useSelector<AppState, AppState['lists']['byUrl']>(state => state.lists.byUrl)
  const pairList = useSelector<AppState, AppState['lists']['pairList']>(state => state.lists.pairList)

  const isWindowVisible = useIsWindowVisible()

  const fetchList = useFetchListCallback()
  const fetchPairList = useFetchPairListCallback()

  const fetchAllListsCallback = useCallback(() => {
    if (!isWindowVisible) return
    Object.keys(lists).forEach(url =>
      fetchList(url).catch(error => console.debug('interval list fetching error', error))
    )
    // Also fetch pair list
    fetchPairList(DEFAULT_PAIR_LIST_URL).catch(error => console.debug('interval pair list fetching error', error))
  }, [fetchList, fetchPairList, isWindowVisible, lists])

  // fetch all lists every 10 minutes, but only after we initialize library
  useInterval(fetchAllListsCallback, library ? 1000 * 60 * 10 : null)

  // whenever a list is not loaded and not loading, try again to load it
  useEffect(() => {
    Object.keys(lists).forEach(listUrl => {
      const list = lists[listUrl]

      if (!list.current && !list.loadingRequestId && !list.error) {
        fetchList(listUrl).catch(error => console.debug('list added fetching error', error))
      }
    })
  }, [dispatch, fetchList, library, lists])

  // fetch pair list if not loaded
  useEffect(() => {
    if (!pairList?.current && !pairList?.loadingRequestId && !pairList?.error) {
      fetchPairList(DEFAULT_PAIR_LIST_URL).catch(error => console.debug('pair list fetching error', error))
    }
  }, [fetchPairList, pairList])

  return null
}
